export default __webpack_public_path__ + "static/media/garden-bench.6f7851d4.png";